import React, { ChangeEvent } from 'react'
import { useCreateAccount } from './hooks'
import {
  CButton,
  CCol,
  CContainer,
  CForm,
  CFormCheck,
  CFormSelect,
  CHeaderText,
  CRow,
} from '@coreui/react-pro'
import { setAccount, submitCreateAccount } from './model'
import { useClientProfile } from '../../../../details'
import { currencyList, leverageList } from './consts'

export const CreateAccountForm = () => {
  const { accountForm, loading, createAccountError } = useCreateAccount()
  const { clientProfile } = useClientProfile()
  const isIndonesianClient = clientProfile.country === 'IDN'

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setAccount({
      ...accountForm,
      [event.currentTarget.name]: value,
    })
  }

  return (
    <CForm className="p-3">
      <CHeaderText className="fw-bold fs-2">Create account</CHeaderText>
      <CRow className="mb-3">
        {createAccountError.code !== 0 && (
          <div className="mt-2 text-danger">
            {`Error: ${createAccountError}`}
          </div>
        )}
      </CRow>
      <CRow className="mb-3">
        <CCol sm={12}>
          <CFormSelect
            label="Currency"
            name="currency"
            placeholder={'Choose currency'}
            value={accountForm.currency}
            onChange={handleChange}
          >
            <option>Choose currency</option>
            {currencyList.map((item) => (
              <option value={item.value}>{item.label}</option>
            ))}
          </CFormSelect>
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol sm={12}>
          <CFormSelect
            label="Account platform"
            name="accountPlatform"
            value={accountForm.accountPlatform}
            onChange={handleChange}
          >
            <option>Choose account platform</option>
            <option value={'1'}>PLATFORM_MT4</option>
            <option value={'2'}>PLATFORM_MT5</option>
          </CFormSelect>
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol sm={12}>
          <CFormSelect
            label="Tariff"
            name="tariff"
            value={accountForm.tariff}
            onChange={handleChange}
          >
            <option>Choose tariff</option>
            <option value={'1'}>TARIFF_STANDARD</option>
            <option value={'2'}>TARIFF_CENT</option>
            <option value={'3'}>TARIFF_PRO</option>
          </CFormSelect>
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol sm={12}>
          <CFormSelect
            label="Leverage"
            name="leverage"
            value={accountForm.leverage}
            onChange={handleChange}
          >
            <option>Choose leverage</option>
            {leverageList.map((item) => (
              <option value={item.value}>{item.label}</option>
            ))}
          </CFormSelect>
        </CCol>
      </CRow>
      {isIndonesianClient && (
        <CRow className="mb-3">
          <CCol sm={12}>
            <CFormSelect
              label="Fix rate"
              name="fixRateValue"
              value={accountForm.fixRateValue}
              onChange={handleChange}
            >
              <option value="0">No fix rate</option>
              <option value="10000">1:10000</option>
              <option value="15000">1:15000</option>
            </CFormSelect>
          </CCol>
        </CRow>
      )}
      <CRow className="mb-3">
        <CCol sm={12}>
          <CFormCheck
            id="isSwapFree"
            name="isSwapFree"
            checked={accountForm.isSwapFree}
            onChange={handleChange}
            label="Is swap free"
          />
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol sm={8} className="d-flex justify-content-end">
          <CButton
            className="mb-3 text-right w-50"
            disabled={
              loading ||
              !accountForm.leverage ||
              !accountForm.accountPlatform ||
              !accountForm.tariff ||
              !accountForm.currency
            }
            onClick={() => {
              const fixRateValue = isIndonesianClient
                ? Number(accountForm.fixRateValue)
                : 0

              submitCreateAccount({
                ...accountForm,
                clientId: clientProfile.clientId,
                leverage: Number(accountForm.leverage),
                tariff: Number(accountForm.tariff),
                accountPlatform: Number(accountForm.accountPlatform),
                fixRateValue,
                isFixRate: fixRateValue !== 0,
              })
            }}
          >
            {loading && (
              <span className="spinner-border spinner-border-sm"></span>
            )}
            Save
          </CButton>
        </CCol>
      </CRow>
    </CForm>
  )
}
